<template>
    <transition>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-alert-header" :style="{'background-color': headerColor ? headerColor : '#5096f5'}">
                        <div class="modal-alert-header-text">메세지</div>
                        <div class="modal-alert-header-close" @click="$emit('close')"></div>
                    </div>
                    <div class="modal-alert-body">
                        <div class="modal-alert-body-inner">
                            <slot name="text">{{text}}</slot>
                        </div>
                        <div>
                            <div class="modal-btn-default modal-btn-cancle" @click="$emit('close')">확인</div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </transition>
</template>
<script>
export default {
    name: 'ModalAlert',
    props: ['text','headerColor'],
}
</script>
<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }
    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
    .modal-container {
        width: 402px;
        max-height:283px;
        min-height:203px;
        margin: 0px auto;        
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }
    .modal-alert-header{
        /* margin-top: 0;
        color: #42b983; */
        display: flex;
        background-color: #5096f5;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
    .modal-alert-header-text {
        display: inline-block;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        margin: 0 26px;
        height: 54px;
        line-height: 54px;
        font-family: nanumBarunLight;
        font-size: 18px;
        color: #fff;
    }
    .modal-alert-header-close{
        display: inline-block;
        cursor: pointer;
        right: 0;
        margin: 16px 26px 0 0;
        width: 22px;
        height: 22px;
        background-image: url('../../../assets/images/popupClose.png');
        background-repeat: no-repeat;
    }
    .modal-alert-body {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .modal-alert-body-inner{
        width: 330px;
        font-family: nanumBarunLight;
        font-size: 16px;
        text-align: center;
        overflow: hidden;
        word-break: break-word;
        margin: 34px 36px 0;
    }
    .modal-default-button {
        float: right;
    }
    .modal-btn-default{
        display: inline-block;
        width: 105px;
        height: 40px;
        margin: 29px 10px 30px;
        border-radius: 3px;
        border: 1px solid #5848b8;
        color: #fff;
        background-color: #6e5ae6;
        text-align: center;
        line-height: 40px;
        font-family: nanumBarunLight;
        font-size: 16px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    .modal-btn-default.modal-btn-cancle{
        background-color: #d8d8d8;
        border: 1px solid #9b9b9b;
        color: #3b3b3b;
    }
    .modal-enter {
        opacity: 0;
    }
    .modal-leave-active {
        opacity: 0;
    }
    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
    .subject-text {
        display: inline-block;
        width: 100%;
        height: 34px;
        padding: 0 10px;
        vertical-align: middle;
        border: 0px;
        color: #fff;
        font-weight: 900;
        font-size: 16px;
        background-color: #5096f5;
        font-family: "Noto Sans KR";
    }
</style>